var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddWhiteEpDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddWhiteEpDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1289.73602,775.191019 L1294.371,770.556035 C1294.79765,770.12938 1294.79765,769.437636 1294.371,769.011041 C1293.94434,768.584385 1293.25266,768.584385 1292.826,769.011041 L1288.19097,773.646085 L1283.55593,769.01098 C1283.12927,768.584324 1282.43759,768.584324 1282.01093,769.01098 C1281.58434,769.437636 1281.58434,770.12938 1282.01093,770.555974 L1286.64597,775.190958 L1282.01093,779.826002 C1281.58434,780.252658 1281.58434,780.944402 1282.01093,781.370996 C1282.43759,781.797652 1283.12927,781.797652 1283.55593,781.370996 L1288.19097,776.735952 L1292.826,781.370996 C1293.2526,781.797652 1293.94434,781.797652 1294.371,781.370996 C1294.79765,780.944341 1294.79765,780.252658 1294.371,779.826002 L1289.73602,775.191019 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-photos-private1",
    transform: "translate(-1279.000000, -766.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icAddWhiteEpDsk",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(1288.190988, 775.190988) rotate(-44.000000) translate(-1288.190988, -775.190988) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddWhiteEpDsk);
export default __webpack_public_path__ + "static/media/icAddWhiteEpDsk.6a53e10ab6197cfc2d9b24a639aed806.svg";
export { ForwardRef as ReactComponent };